import React from "react";
import { Menu } from "antd";
import { items } from "../../constants/items.constant";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/auth.context";
import { UserRole } from "../../types/user.type";

export default function Sidebar({ darkTheme }: { darkTheme: boolean }) {
  const { authState } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  const userRole = authState.user?.role as UserRole;

  const filteredItems = items.filter(
    (item) =>
      item &&
      item.icon &&
      (item.roles.includes(userRole) ||
        (item.children &&
          item.children.some((child) => child.roles.includes(userRole))))
  );

  return (
    <Menu
      onClick={(item) => {
        navigate(item.key);
      }}
      selectedKeys={[currentPath]}
      items={filteredItems}
      theme={darkTheme ? "dark" : "light"}
      mode="inline"
      style={{
        fontSize: "1rem",
        marginTop: 80,
      }}
    />
  );
}
